import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { paymentMethodCreate } from '../../../redux/actions/paymentMethods';

const NewPaymentMethodModal = ({ payload, showNewPaymentMethodModal, setShowNewPaymentMethodModal, newPaymentMethod }) => {
  const [methodName, setMethodName] = useState(null);

  const paymentMethod = () => {
    return {
      method_name: methodName
    }
  }

  const changeName = (event) => {
    let value = event.target.value;
    setMethodName(value);
  }


  const create = () => {
    newPaymentMethod(payload, paymentMethod());
    setShowNewPaymentMethodModal(false);
  }

  return(
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowNewPaymentMethodModal(false),
          },
          { text: 'New Payment Method', onClick: () => create() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="New Payment Method"
        isOpen={showNewPaymentMethodModal}
        onClose={() => setShowNewPaymentMethodModal(false)}
      >
        <H3>New Payment Method</H3>
        <Input
          description="Payment Method Name"
          label="Payment Method Name"
          onChange={changeName}
          placeholder="Payment Method Name"
          type="text"
          value={methodName}
          required
        />
      </Modal>
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  newPaymentMethod: (payload, paymentMethod) => dispatch(paymentMethodCreate(payload, paymentMethod)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewPaymentMethodModal);